import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import i18n from './utils/i18n';
import './assets/css/app.css';
// eslint-disable-next-line
import Shimmer from 'vue3-shimmer';
import VueAwesomePaginate from "vue-awesome-paginate";
import VNetworkGraph from "v-network-graph"
import "v-network-graph/lib/style.css"

const app = createApp(App);

// Initialize Pinia before using any stores
const pinia = createPinia();
app.use(pinia);

// Use other plugins
app.use(VNetworkGraph)
app.use(router);
app.use(i18n);
app.use(Shimmer);
app.use(VueAwesomePaginate);

// Mount the app
app.mount('#app');